import { Component, Input, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-vinculos-representados-modal',
  templateUrl: './vinculos-representados-modal.component.html',
  styleUrls: ['./vinculos-representados-modal.component.scss']
})
export class VinculosRepresentadosModalComponent implements OnInit {

  @Input() itens: any[] = [];

  constructor(
    private modalRef: NzModalRef,
  ) { }

  ngOnInit() {
    if (!Array.isArray(this.itens)) {
      console.warn('A entrada "itens" não é uma lista válida.');
      this.itens = [];
    }
  }

  handleOk(): void {
    this.modalRef.close(true);
  }

  handleCancel(): void {
    this.modalRef.close(false);
  }

  abrirEmNovaGuia(id: number): void {
    const url = `/#/vinculo/editar/${id}`;
    window.open(url, '_blank');
  }

  handleProsseguir(): void {
    this.modalRef.close(true);
  }
}
